import { Field } from 'formik'

import { Label } from '@components/UI/Form/Label'
import { useAffiliateInfo } from '@hooks/affiliate-info'

interface AffiliateCommentsProps {
  partner: string
  hasIntegration: boolean
}

export function AffiliateComments(props: AffiliateCommentsProps) {
  const { data } = useAffiliateInfo(props.partner)

  return (
    <div className="flex">
      {data?.logo && (
        <img src={data.logo} className="mr-8 w-28 h-28 rounded bg-white" />
      )}
      <div className="w-full">
        <div className="bg-blue-100 text-brand p-8 rounded shadow-sm flex items-center">
          {data?.price.offered !== '59' ? (
            <p className="font-bold">
              Thank you for purchasing a home inspection from {data?.name}.{' '}
              {data?.name} is a proud affiliate with Majordomo, which means they
              may earn a commission at no extra cost to you.
            </p>
          ) : (
            <p className="font-bold">
              Thank you for purchasing a home inspection from {data?.name}.{' '}
              {data?.name} is offering this service to you because they believe
              it adds value. However, they have no financial arrangement with
              Majordomo. They do not earn a commission, nor any other form of
              compensation.
            </p>
          )}
        </div>
        {props.hasIntegration && (
          <div className="mt-4 bg-yellow-200 text-yellow-900 p-8 rounded shadow-sm items-center font-bold">
            <p>
              To make your life easier, we can retrieve a copy of your
              inspection on your behalf. If you would prefer to upload your
              inspection instead, you can opt out of this.
            </p>
            <div className="mt-4 rounded p-4 bg-gray-50 flex items-center">
              <Field
                type="checkbox"
                id="integrationConsent"
                name="integrationConsent"
                className="mr-4"
              />
              <Label htmlFor="integrationConsent">
                I allow Majordomo to retrieve a copy of my inspection
              </Label>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
